import React, { useContext, useEffect, useCallback } from 'react';
import { Portal } from 'react-portal';

import formatPrice from 'app/utils/price';
import { isDesktop } from 'app/utils/resolution';

import { BasketCheckPromocodeForm } from 'app/views/Basket/components/BasketCheck/BasketCheckRows';

import { BasketContext } from './BasketProvider';
import { BillingContext } from './BillingProvider';


export function BasketTotalPortal() {
    const {
        basket,
        promocodeConditions,
    } = useContext(BasketContext);

    const {
        updateBilling,
        billingState: { promocode },
    } = useContext(BillingContext);

    const applyPromocode = useCallback((nextPromocode) => {
        updateBilling({ promocode: nextPromocode });
    }, [updateBilling]);

    const priceElements = Array.from(document.querySelectorAll('[data-price-total-portal]'));
    const originalPriceElements = Array.from(document.querySelectorAll('[data-original-price-total-portal]'));
    const promocodeEl = document.querySelector('[data-promocode-container-portal]');

    useEffect(() => {
        if (basket.totals.onlinePrice >= 0) {
            const hidden = document.querySelector('.preloader--on-mount');
            if (hidden) {
                hidden.classList.remove('preloader--on-mount');
            }
        }
    }, [basket.totals.onlinePrice]);

    if (priceElements.length === 0) return null;

    const price = formatPrice(basket.totals.onlinePrice);
    const originalPrice = formatPrice(basket.totals.total_price);
    const heightType = isDesktop() ? 'small' : 'large';

    return (
        <>
            {priceElements.map((el, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <Portal node={el} key={index}>
                    {price}
                    <span className="rub">₽</span>
                </Portal>
            ))}
            {originalPriceElements.map((el, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <Portal node={el} key={index}>
                    {originalPrice !== price
                        ? (
                            <>
                                {originalPrice}
                                &nbsp;
                                <span className="rub">₽</span>
                            </>
                        )
                        : ''}
                </Portal>
            ))}
            {promocodeEl && (
                <Portal node={promocodeEl}>
                    <BasketCheckPromocodeForm
                        promocode={promocode}
                        discountConditions={promocodeConditions}
                        setIsWelcomeDiscountShown={() => {}}
                        applyPromocodeHandler={applyPromocode}
                        defaultLabel="Промокод"
                        showConfirmedLabel
                        heightType={heightType}
                    />
                </Portal>
            )}
        </>
    );
}
